import * as Yup from "yup";

type IBeaconSchema = {
  uuid: string;
  major?: number;
  minor?: number;
};

const beaconSchema: Yup.ObjectSchema<IBeaconSchema> = Yup.object().shape({
  uuid: Yup.string()
    .matches(
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
      "It is not a UUID format."
    )
    .required("UUID is required."),
  major: Yup.number().required("Major is required."),
  minor: Yup.number().required("Minor is required."),
});

const clearData: IBeaconSchema = {
  uuid: "",
};

export { beaconSchema, clearData };
export type { IBeaconSchema };
